/**
 * Calendar Card Themes
 * 
 * Color system for calendar workout cards.
 * Neutral backgrounds matching Dashboard card styling.
 * Uses CSS custom properties for theme compatibility.
 */

export interface CardTheme {
  base: string;
  text: string;
  secondary: string;
  sparkline: string;
  accent: string;
  showSparkline: boolean;
  showPace: boolean;
}

// Neutral card background - matches shadcn Card bg-card (same as Dashboard Today's Session)
// From index.css: .dark { --card: 220 25% 11%; --muted-foreground: 220 10% 55%; }
const CARD_BG_COMPLETED = 'hsl(220 25% 11%)';   // Matches --card dark mode exactly
const CARD_BG_PLANNED = 'hsl(217 30% 14%)';     // Slightly lighter/bluer — distinguishes planned
const TEXT_PRIMARY = 'hsl(0 0% 98%)';            // --foreground dark
const TEXT_SECONDARY = 'hsl(220 10% 55%)';       // --muted-foreground dark

// Accent colors for differentiation (subtle, used for traces/badges)
const ACCENT_COMPLETED = 'hsl(142 71% 45%)'; // Green - completed
const ACCENT_PLANNED = 'hsl(217 91% 60%)';   // Blue - planned  
const ACCENT_STRENGTH = 'hsl(270 60% 60%)';  // Purple - strength

export const CALENDAR_CARD_THEMES: Record<string, CardTheme> = {
  // Completed Activity (Running default)
  'completed-running': {
    base: CARD_BG_COMPLETED,
    text: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
    sparkline: ACCENT_COMPLETED,
    accent: ACCENT_COMPLETED,
    showSparkline: true,
    showPace: true,
  },
  'completed-cycling': {
    base: CARD_BG_COMPLETED,
    text: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
    sparkline: ACCENT_COMPLETED,
    accent: ACCENT_COMPLETED,
    showSparkline: true,
    showPace: false,
  },
  'completed-swimming': {
    base: CARD_BG_COMPLETED,
    text: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
    sparkline: ACCENT_COMPLETED,
    accent: ACCENT_COMPLETED,
    showSparkline: true,
    showPace: false,
  },
  
  // Planned Session — slightly lighter/bluer background
  'planned-running': {
    base: CARD_BG_PLANNED,
    text: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
    sparkline: ACCENT_PLANNED,
    accent: ACCENT_PLANNED,
    showSparkline: false,
    showPace: false,
  },
  'planned-cycling': {
    base: CARD_BG_PLANNED,
    text: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
    sparkline: ACCENT_PLANNED,
    accent: ACCENT_PLANNED,
    showSparkline: false,
    showPace: false,
  },
  'planned-swimming': {
    base: CARD_BG_PLANNED,
    text: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
    sparkline: ACCENT_PLANNED,
    accent: ACCENT_PLANNED,
    showSparkline: false,
    showPace: false,
  },
  
  // Workout / Strength / Cross
  'strength': {
    base: CARD_BG_COMPLETED,
    text: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
    sparkline: ACCENT_STRENGTH,
    accent: ACCENT_STRENGTH,
    showSparkline: false,
    showPace: false,
  },

  // Rest / Recovery
  'rest': {
    base: 'hsl(220 20% 10%)',
    text: TEXT_PRIMARY,
    secondary: TEXT_SECONDARY,
    sparkline: 'hsl(220 15% 40%)',
    accent: 'hsl(220 15% 40%)',
    showSparkline: false,
    showPace: false,
  },
};
